//redux
import { isArray } from "lodash"
import { useSelector } from "react-redux"

// *************************************************************
//     Misc
export function useCampusVirtualIdCampus() {
  return useSelector(state => state.CampusVirtual.context.idCampus)
}

export function useCampusVirtualListaCampus() {
  return useSelector(state => state.CampusVirtual.context.listaCampus)
}

export function useCampusVirtualIsLoading() {
  return useSelector(state => state.CampusVirtual.context.loading)
}

export function useCampusVirtualIsLoadingUltimosRecibos() {
  return useSelector(state => state.CampusVirtual.context.loadingUltimosRecibos)
}

export function useCampusVirtualIsLoadingDataSegmentos() {
  return useSelector(state => state.CampusVirtual.context.loadingDataSegmentos)
}

export function useCampusVirtualIsLoadingSendLinkPagoEmail() {
  return useSelector(
    state => state.CampusVirtual.context.loadingSendLinkPagoEmail
  )
}

export function useCampusVirtualIsLoadingAlumnosSegmentados() {
  return useSelector(
    state => state.CampusVirtual.context.loadingAlumnosSegmentados
  )
}

export function useCampusVirtualIsLoadingCartera() {
  return useSelector(state => state.CampusVirtual.context.loadingCartera)
}

export function useCampusVirtualListaCampusActivosDisplay() {
  const listaCampus = useCampusVirtualListaCampus()

  return listaCampus.filter(
    campus => campus.Activo === true && campus.Display === true
  )
}

export function useCampusVirtualListaCampusActivosDisplayconPermiso() {
  const user = useCampusVirtualAuthenticatedUser()
  const listaCampus = useCampusVirtualListaCampus()

  return obtenerCampusPorRoles(user.Lista_Roles, listaCampus)
}

export function useCampusVirtualNombreCampusSeleccionado() {
  const listaCampus = useCampusVirtualListaCampus()
  const idCampus = useCampusVirtualIdCampus()

  const campus = listaCampus.find(item => item.id_Campus == idCampus)

  // Si encuentra el campus, retorna su Nombre_Campus; si no, retorna un mensaje de error
  return campus ? campus.Nombre_Campus : "Campus no encontrado"
}

export function useCampusVirtualAuthenticatedUser() {
  return useSelector(state => state.CampusVirtual.context.authenticatedUser)
}

export function useCampusVirtualDataDashboardCobranza() {
  return useSelector(state => state.CampusVirtual.context.dataDashboardCobranza)
}

export function useCampusVirtualDataDashboardCobranzaComparativa() {
  return useSelector(
    state => state.CampusVirtual.context.dataDashboardCobranzaComparativa
  )
}

export function useCampusVirtualConfiguracion() {
  return useSelector(state => state.CampusVirtual.context.configuraciones)
}

export function useCampusVirtualDataSegmentos() {
  return useSelector(state => state.CampusVirtual.context.dataSegmentos)
}

export function useCampusVirtualAlumnosSegmentados() {
  return useSelector(state => state.CampusVirtual.context.alumnosSegmentados)
}

export function useCampusVirtualResumenPuntualidad() {
  return useSelector(state => state.CampusVirtual.context.resumenPuntualidad)
}

export function useCampusVirtualMensajeExitoso() {
  return useSelector(state => state.CampusVirtual.context.mensajeExitoso)
}

// ***************************
// Ingresos Egresos
export function useCampusVirtualIngresosEgresos() {
  return useSelector(state => state.CampusVirtual.context.ingresosEgresos)
}

export function useCampusVirtualDataChartIngresosEgresosMeses(mesesAtras) {
  const ingresosEgresos = useSelector(
    state => state.CampusVirtual.context.ingresosEgresos
  )

  if (!Array.isArray(ingresosEgresos)) {
    console.error("Error: La variable 'ingresosEgresos' no es un array.")
    return []
  }

  // Obtener la fecha actual y calcular el primer día del mes correspondiente
  let fechaActual = new Date()
  fechaActual.setMonth(fechaActual.getMonth() - mesesAtras)
  let año = fechaActual.getFullYear()
  let mes = fechaActual.getMonth() + 1 // getMonth() es base 0

  // Formatear el mes para que tenga dos dígitos (ejemplo: "02" en vez de "2")
  let mesStr = mes < 10 ? `0${mes}` : `${mes}`

  // Obtener el número de días del mes solicitado
  const fechaReferencia = new Date(`${año}-${mesStr}-01`)
  const diasEnMes = new Date(año, mes, 0).getDate()

  // Inicializar arreglos con ceros para cada día del mes
  let ingresosPorDia = new Array(diasEnMes).fill(0)
  let egresosPorDia = new Array(diasEnMes).fill(0)

  // Recorrer los datos y sumar ingresos y egresos por día solo para el mes solicitado
  ingresosEgresos.forEach(item => {
    let fecha = new Date(item.Fecha)
    let itemAño = fecha.getFullYear()
    let itemMes = fecha.getMonth() + 1

    if (itemAño === año && itemMes === mes) {
      let dia = fecha.getDate() // Obtener el día del mes
      ingresosPorDia[dia - 1] += item.Total_Ingresos || 0 // Acumular ingresos en la posición correspondiente
      egresosPorDia[dia - 1] += item.Total_Gastos || 0 // Acumular egresos en la posición correspondiente
    }
  })

  // Estructura de datos para la serie
  const series = [
    {
      name: "Ingreso",
      data: [...ingresosPorDia],
    },
    {
      name: "Egreso",
      data: [...egresosPorDia],
    },
  ]

  return series
}

// ***************************

export function useCampusVirtualConfiguracion_xNombre(nombreBuscado) {
  const configuraciones = useSelector(
    state => state.CampusVirtual.context.configuraciones
  )
  let itemEncontrado = null
  if (configuraciones && isArray(configuraciones)) {
    itemEncontrado = configuraciones.find(item => item.Nombre === nombreBuscado)
  }
  // Si se encontró, retorna su valor; si no, retorna null
  return itemEncontrado ? itemEncontrado.Valor : null
}

export function useCampusVirtualDataDashboardUltimosRecibos() {
  return useSelector(
    state => state.CampusVirtual.context.dataDashboardUltimosRecibos
  )
}

export function useCampusVirtualOptionsListaCampus(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaCampusLight
  )
  let Options = options.map(option => {
    //console.log(option)
    return {
      value: option.id_Campus,
      label: option.Nombre_Campus,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCampusVirtualOptionsListaProgramasAcademicos(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaCarrerasLight
  )
  let Options = options.map(option => {
    return {
      value: option.id_Programa_Academico,
      label: option.Nombre_Programa_Academico,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCampusVirtualOptionsListaPlanesEstudio(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaPlanesLight
  )
  let Options = options.map(option => {
    return {
      value: option.id_Plan_Estudio,
      label: option.Nombre_Plan_Estudio,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCampusVirtualGetidNivelEducativoxidPlanEstudioInPlanesLight(
  id_Plan_Estudio
) {
  const planes = useSelector(
    state => state.CampusVirtual.context.listaPlanesLight
  )
  const plan = planes.find(
    plan => plan.id_Plan_Estudio === Number(id_Plan_Estudio)
  )
  return plan ? plan.id_Nivel_Educativo : null
}

export function useCampusVirtualOptionsListaTurnos(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaTurnosLight
  )
  let Options = options.map(option => {
    return {
      value: option.id_Turno,
      label: option.Nombre_Turno,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCampusVirtualOptionsListaTrayectorias(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaTrayectoriasLight
  )
  let Options = options.map(option => {
    return {
      value: option.id_Trayectoria,
      label: option.Nombre_Trayectoria,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export function useCampusVirtualOptionsListaStatus(elige = false) {
  const options = useSelector(
    state => state.CampusVirtual.context.listaStatusLight
  )
  let Options = options.map(option => {
    return {
      value: option.id_Status,
      label: option.Nombre_Status,
    }
  })
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

function obtenerCampusPorRoles(Lista_Roles, campi) {
  const prefijo = "sis_usuarios_campus_"
  const numeros = []

  for (let key in Lista_Roles) {
    const value = Lista_Roles[key]
    if (typeof value === "string" && value.startsWith(prefijo)) {
      const numero = value.slice(prefijo.length)
      if (!isNaN(numero)) {
        if (parseInt(numero, 10) === 0) {
          return campi
        }
        // Verifica que sea un número
        numeros.push(parseInt(numero, 10))
      }
    }
  }

  // Filtrar los campus cuyos id_Campus coincidan con los números extraídos
  const campusFiltrados = campi.filter(campus =>
    numeros.includes(campus.id_Campus)
  )

  return campusFiltrados
}
